import { __decorate, __metadata, __param } from "tslib";
import { Inject } from '@angular/core';
import { SessionStorageService } from 'angular-web-storage';
var TokenHandlerService = /** @class */ (function () {
    function TokenHandlerService(session) {
        this.session = session;
        this.KEY = 'e';
        this.token = 'none';
    }
    TokenHandlerService.prototype.setToken = function (newToken) {
        this.token = newToken;
    };
    TokenHandlerService.prototype.getToken = function () {
        return this.token;
    };
    TokenHandlerService.prototype.setEParam = function (eParam) {
        this.session.set(this.KEY, eParam);
    };
    TokenHandlerService.prototype.getEParam = function () {
        return this.session.get(this.KEY);
    };
    TokenHandlerService.prototype.clear = function () {
        this.session.clear();
    };
    TokenHandlerService = __decorate([
        __param(0, Inject(SessionStorageService)),
        __metadata("design:paramtypes", [SessionStorageService])
    ], TokenHandlerService);
    return TokenHandlerService;
}());
export { TokenHandlerService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4taGFuZGxlci5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vd29ya3BsYWNlTGl2aW5nU2VydmljZXMvc3JjL2FwcC9zZXJ2aWNlcy90b2tlbi1oYW5kbGVyLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxNQUFNLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFFckMsT0FBTyxFQUFDLHFCQUFxQixFQUFDLE1BQU0scUJBQXFCLENBQUM7QUFFMUQ7SUFLRSw2QkFBMEQsT0FBOEI7UUFBOUIsWUFBTyxHQUFQLE9BQU8sQ0FBdUI7UUFIaEYsUUFBRyxHQUFHLEdBQUcsQ0FBQztRQUNWLFVBQUssR0FBRyxNQUFNLENBQUM7SUFHdkIsQ0FBQztJQUVNLHNDQUFRLEdBQWYsVUFBZ0IsUUFBUTtRQUN0QixJQUFJLENBQUMsS0FBSyxHQUFHLFFBQVEsQ0FBQztJQUN4QixDQUFDO0lBRU0sc0NBQVEsR0FBZjtRQUNFLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQztJQUNwQixDQUFDO0lBRU0sdUNBQVMsR0FBaEIsVUFBaUIsTUFBTTtRQUNyQixJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3JDLENBQUM7SUFFTSx1Q0FBUyxHQUFoQjtRQUNFLE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ3BDLENBQUM7SUFFTSxtQ0FBSyxHQUFaO1FBQ0UsSUFBSSxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQztJQUN2QixDQUFDO0lBMUJVLG1CQUFtQjtRQUtWLFdBQUEsTUFBTSxDQUFDLHFCQUFxQixDQUFDLENBQUE7eUNBQWtCLHFCQUFxQjtPQUw3RSxtQkFBbUIsQ0EyQi9CO0lBQUQsMEJBQUM7Q0FBQSxBQTNCRCxJQTJCQztTQTNCWSxtQkFBbUIifQ==